module.exports = __webpack_public_path__ + "img/ArgCroacia.7071d5c1.jpg";